/* eslint-disable max-lines */
import * as api from './ReportsApi';
import * as type from './ReportsType';
import { messages } from '../../lang/en';
import { getNamespace } from '../../utils/storage';
const config = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
};
export const getPatientReports =
    (patientId, offset = 0, limit = 100, service = api.getAPatientReports) =>
    async (dispatch) => {
        dispatch({
            type: type.GET_PATIENT_REPORTS.REQUEST
        });
        const namespace = getNamespace();
        return await service(patientId, offset, limit, namespace).then((response) => {
            dispatch({
                type: type.GET_PATIENT_REPORTS.SUCCESS,
                payload: response.data
            });
        });
    };
export const postPatientReport =
    (patientId, values, time, service = api.postAPatientReport) =>
    async (dispatch) => {
        const namespace = getNamespace();
        const data = {
            namespace,
            patient_id: patientId,
            report_type_id: values.type.id,
            location_ids: values.locations,
            admission_id: null,
            content: values.content,
            reported: time,
            requester: values.requester !== '' ? values.requester : null,
            provider: values.provider !== '' ? values.provider : null
        };
        const { images } = values;
        return await service(data).then(async (response) => {
            const successDispatches = (newImages) => {
                return new Promise((resolve) => {
                    let completedImagesArray;
                    // if user POST any photo the longest array
                    // of images will be replaced in images part
                    // (last existed images are included!)
                    if (newImages.length !== 0) {
                        completedImagesArray = newImages.reduce(function (a, b) {
                            return a.length > b.length ? a : b;
                        });
                    }
                    const newData = {
                        ...response.data,
                        images:
                            newImages?.length !== 0
                                ? [...completedImagesArray]
                                : [...response.data.images]
                    };
                    dispatch({
                        type: type.UPDATE_CREATE_REPORT,
                        id: response.data.id,
                        data: newData,
                        allLocations: values.allLocationsForm
                    });
                    dispatch({
                        type: 'ADD_MESSAGE',
                        payload: {
                            text: messages.postActionAlert.reportSubmitted,
                            status: 200
                        }
                    });
                    resolve({ status: 200, data: newData });
                });
            };
            const dispatchImage = (image, index) => {
                return new Promise((resolve, reject) => {
                    dispatch(postImage(image, response, index))
                        .then((val) => {
                            resolve(val);
                        })
                        .catch(() => {
                            reject('ERROR DAR YEK AX!');
                        });
                });
            };
            const wrapperCatchFunction = (image, index) => {
                return dispatchImage(image, index).catch(() => dispatchImage(image, index));
            };
            const promisePostImages = async () => {
                // let newImages;
                const values = await Promise.all(
                    images?.map((image, index) => wrapperCatchFunction(image, index))
                );

                return successDispatches(values);
            };
            const newData =
                images?.length !== 0 ? await promisePostImages() : await successDispatches([]);

            return newData;
        });
    };
export const deletePatientReport =
    (reportId, service = api.deleteAPatientReport) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(reportId, namespace).then(({ status }) => {
            if (status === 200) {
                dispatch({
                    type: type.DELETE_REPORT,
                    payload: reportId
                });
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: messages.postActionAlert.reportDeleted,
                        status: 200
                    }
                });
            }
        });
    };
export const deleteReportImage =
    (reportId, imageId, service = api.deleteAPatientReportImage) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(reportId, imageId, namespace).then((response) => {
            dispatch({
                type: type.DELETE_IMAGE_FROM_REPORT,
                reportId: reportId,
                updatedReport: response.data
            });
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: messages.postActionAlert.imageDeleted,
                    status: 200
                }
            });

            return response;
        });
    };
export const putPatientReport =
    (reportId, values, time, service = api.putAPatientReport) =>
    async (dispatch) => {
        const namespace = getNamespace();
        const data = {
            namespace,
            report_type_id: values.type.id,
            location_ids: values.locations,
            admission_id: null,
            content: values.content,
            reported: time,
            requester: values.requester !== '' ? values.requester : null,
            provider: values.provider !== '' ? values.provider : null
        };
        const { images } = values;
        return await service(reportId, data).then(async (response) => {
            const successDispatches = (newImages) => {
                return new Promise((resolve) => {
                    let completedImagesArray;
                    // if user POST any photo the longest array
                    // of images will be replaced in images part
                    // (last existed images are included!)
                    if (newImages.length !== 0) {
                        completedImagesArray = newImages.reduce(function (a, b) {
                            return a.length > b.length ? a : b;
                        });
                    }
                    const newData = {
                        ...response.data,
                        images:
                            newImages.length !== 0
                                ? [...completedImagesArray]
                                : [...response.data.images]
                    };
                    dispatch({
                        type: type.UPDATE_CREATE_REPORT,
                        id: response.data.id,
                        data: newData,
                        allLocations: values.allLocationsForm
                    });
                    dispatch({
                        type: 'ADD_MESSAGE',
                        payload: {
                            text: messages.postActionAlert.reportEdited,
                            status: 200
                        }
                    });
                    resolve({ status: 200, data: newData });
                });
            };
            const dipsatchImage = (image, index) => {
                return new Promise((resolve, reject) => {
                    dispatch(postImage(image, response, index))
                        .then((val) => {
                            resolve(val);
                        })
                        .catch(() => {
                            reject('ERROR DAR YEK AX!');
                        });
                });
            };
            const wrapperCatchFunction = (image, index) => {
                return dipsatchImage(image, index).catch(() => dipsatchImage(image, index));
            };
            const promisePostImages = async () => {
                // let newImages;
                const values = await Promise.all(
                    images?.map((image, index) => wrapperCatchFunction(image, index))
                );
                return successDispatches(values);
            };
            const newData =
                images?.length !== 0 ? await promisePostImages() : await successDispatches([]);

            return newData;
        });
    };
export const getAReportAllLocation =
    (typeId, typeObject, offset = 1, limit = 100, service = api.getAllReportLocation) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(offset, limit, typeId, namespace)?.then((response) => {
            if (typeObject) return response;
            dispatch({
                type: type.SELECT_LOCATIONS_INITIAL_DIALOG,
                payload: response.data.report_locations
            });
        });
    };
export const getAllTypes =
    (service = api.getAllReportType) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(namespace).then((response) => {
            dispatch({ type: type.SET_ALL_TYPES, payload: response.data.report_types });
        });
    };
export const resetSelectReport = () => (dispatch) => {
    dispatch({
        type: type.RESET_SELECT_THE_REPORT
    });
};
export const selectTheReport = (data) => (dispatch) => {
    dispatch({
        type: type.SELECT_THE_REPORT,
        payload: [
            data?.id,
            data?.content,
            data?.requester,
            data?.provider,
            data?.reported,
            data?.images,
            data?.report_type,
            data?.locations?.map((location) => location.id),
            data?.locations?.map((i) => i.name)
        ]
    });
};
const postImage = (image, response) => async (dispatch) => {
    // if (index === 1 && !state) {
    //     throw new Error('sag!');
    // }
    const namespace = getNamespace();
    const form = new FormData();
    form.append('image', image.file);
    form.append('namespace', namespace);
    return await api
        .addImageToPatientReport(response.data.id, form, config)
        ?.then((responseImage) => {
            dispatch({
                type: type.UPDATE_CREATE_REPORT,
                id: response.data.id,
                data: responseImage.data
            });
            // dispatch({
            //     type: 'ADD_MESSAGE',
            //     payload: {
            //         text: `عکس ${index} با موفقیت آپلود شد`,
            //         status: 200
            //     }
            // });
            return responseImage.data.images;
        })
        .catch((error) => error);
};
